import React, { useState, useEffect } from "react";
import UserService from "../Setup/controller/UserController/UserController";
import { useNavigate } from "react-router-dom";

const UserDropdown = ({ value, onChange, showLabel = true }) => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const redirectCallback = () => navigate("/");
      const usersData = await UserService.getAllUsers(redirectCallback);
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  return (
    <div className="w-100">
      {showLabel && <label className="form-label">Select User</label>}
      <select
        className="form-control"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select Engineer</option>
        {users.map((user) => (
          <option key={user.UserID} value={user.UserID}>
            {user.DisplayName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default UserDropdown;
